import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12" data-id="element-123" data-mp="9ucs18y43p3p">
      <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-4 rounded-3xl border border-success/25 bg-success-soft p-6 text-center md:p-8" data-id="element-124" data-mp="etz3pdyakxae">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-surface" data-id="element-125" data-mp="jsafvvc27jvs">
          <ShieldCheckIcon size={28} className="text-success" data-id="element-126" data-mp="nsb4u9wsbdh3" />
        </span>
        <div data-id="element-127" data-mp="sm5hwuhvwu77">
          <h2 id="garantia" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-128" data-mp="slmcuedc20al">
            Garantía de 7 días
          </h2>
          <p className="mt-1 text-sm font-bold uppercase tracking-[0.16em] text-success" data-id="element-129" data-mp="12kbhv6k4rq9f">
            Exploralo. Estudialo. Decidí tranquilo.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-130" data-mp="25rnjh0sl8ott">
            Accedé a {PRODUCT}, revisá los materiales y comenzá a utilizar el
            método. Si dentro de los primeros 7 días considerás que no cumple
            con lo ofrecido,{' '}
            <span className="font-semibold text-ink" data-id="element-131" data-mp="1rs5qsac68rf6">
              podés solicitar tu devolución
            </span>{' '}
            según las condiciones de compra.
          </p>
        </div>
      </Reveal>
    </section>;
}